import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <p>{`Curious developer interested in solving ridiculous problems and creating super cute applications.`}</p>
    <p>{`Cat lover, gamer, tea-addict, fantasy nerd, and kindness enthusiast.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      